export class CustomerObjectDeviceDto {
    customerObjectDeviceId: number;
    customerObjectId: number;
    requestCategoryId: number;
    requestCategoryName: string;
    deviceId: number;
    deviceStatusName: string;
    deviceTypeId: number;
    deviceTypeName: string;
    deviceModelId: number;
    deviceModelName: string;
    deviceSupplierId: number;
    deviceSupplierName: string;
    serialNumber: string;
    article: string;
    installTypeId: number;
    installTypeName: string;
    marketPlaceId: number;
    marketPlaceName: string;
    existInRequestDevices: boolean;
    manufactureDate: Date;
    installationDate: Date;
    lastServiceDate: Date;
    isMainDevice: boolean;
    isExpendable: boolean;
    lastRequestId?: number;
    lastRequestTypeName: string;
    lastRequestDate?: Date;
}